
export const JobPartValidation = (formData) => {
    const errors = {};
   
    if (!formData.selectedParts.length===0) {
        errors.selectedParts = 'Please select at least one record.';
    }
    return errors;
};
